<template>
    <MainLayout>
        <LoaderPage v-if="loadingPage" />
        <HeaderBreadcrumb
            :items="items"
            :page="page"
        />
        <div class="container min-vh-100">
            <div class="m-3 text-center">
                <h2>Leituras automáticas</h2>
                <p>(Por padrão, o sistema realiza duas leituras diárias, uma às 4h e outra às 16h)</p>
            </div>
            <div class="d-flex flex-column align-items-center">
                <div class="card w-75">
                    <div class="card-body">
                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between align-items-center" v-for="horario in horarios" :key="horario.id">
                                <span style="margin-left: 1vh;">{{ horario.horario.substring(0, 5) }}</span>
                                <button style="border: none; background: none;" :disabled="!permissaoEditar" @click="removerHorario(horario.id)">
                                    <i class="fas fa-times"></i>
                                </button>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <input :disabled="!permissaoEditar" class="form-control w-50" type="time" v-model="novoHorario">
                                <button :disabled="!permissaoEditar" class="btn btn-primary" @click="adicionarHorario()">Adicionar</button>
                            </li>
                        </ul>
                        <div class="d-flex justify-content-center mt-3">
                            <button :disabled="!permissaoEditar || salvandoLoading" class="btn btn-success mx-2" @click="salvarHorarios">Salvar</button>
                            <button :disabled="!permissaoEditar" class="btn btn-secondary mx-2" @click="resetHorarios">Reverter alterações</button>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout.vue';
import HeaderBreadcrumb from '@/components/ui/App/HeaderBreadcrumb.vue';
import LoaderPage from '@/components/ui/LoaderPage.vue';
import { useToast } from 'vue-toastification';
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';

export default {
    components: {
        MainLayout,
        HeaderBreadcrumb,
        LoaderPage
    },

    data() {
        return {
            items: [
                {"descricao": "Winckieel", "url": "/v1/unidades"},
                {"descricao": "Unidade", "url": "/v1/unidades/"+ this.$route.params.unidade}, 
            ],
            page: "Leituras automáticas"
        }
    },

    setup() {
        const store = useStore();
        const toast = useToast();
        const loadingPage = ref(true);
        const route = useRoute();
        const horarios = ref([]);
        const horariosBackup = ref([]);
        const novoHorario = ref('');
        const permissaoEditar = ref(false);
        const salvandoLoading = ref(false);

        onMounted(async () => {
            loadingPage.value = true;
            const unidadeId = route.params.unidade;
            permissaoEditar.value = store.state.unidade.unidade.permissoes?.alteracao_leitura_automatica || false;

            try {
                const response = await store.dispatch("leituras/getLeiturasAutomaticas", unidadeId);
                horarios.value = response;
                horariosBackup.value = structuredClone(response);

            } catch (error) {
                console.error("Erro ao buscar leituras:", error);
                toast.error("Erro ao buscar leituras");
            }
            loadingPage.value = false;
        });

        const removerHorario = async (horarioId) => {
            horarios.value = horarios.value.filter(horario => horario.id !== horarioId);
            toast.info("Horário removido, clique em SALVAR para manter as alterações");
        };

        const adicionarHorario = async () => {
            if (!novoHorario.value) {
                toast.error("Por favor, insira um horário válido");
                return;
            }

            try {
                horarios.value.push({
                    id: Date.now(),
                    unidade_id: route.params.unidade,
                    horario: novoHorario.value + ":00",
                    status: 1,
                    created_at: new Date().toISOString(),
                    updated_at: new Date().toISOString()
                });
                novoHorario.value = '';
                toast.info("Horário adicionado, clique em SALVAR para manter as alterações");
            } catch (error) {
                console.error("Erro ao adicionar horário:", error);
                toast.error("Erro ao adicionar horário");
            }
        };

        const resetHorarios = () => {
            horarios.value = structuredClone(horariosBackup.value);
            toast.info("Alterações canceladas");
        };

        const salvarHorarios = async () => {
            salvandoLoading.value = true;
            const horariosASalvar = horarios.value.map(horario => ({
                horario: horario.horario.substring(0, 5),
                status: horario.status
            }));
            try {
                const unidadeId = route.params.unidade;
                let response = await store.dispatch("leituras/salvarLeiturasAutomaticas", { unidadeId, horariosASalvar });
                toast.info("Dados enviados ao Painel TermoWeb, aguardando confirmação...", { timeout: 3900 });
                horariosBackup.value = structuredClone(horarios.value);
                let messageId = response.data.message.message_id;
                setTimeout(async () => {
                    let msg = await store.dispatch("message/fetchMessage", messageId);
                    if (msg.status != 'processed') {
                        toast.error("Atualização nos horários não processada pelo Painel TermoWeb.");
                    } else {
                        toast.success("Horários atualizados com sucesso.");
                    }
                }, 4000);
            } catch (error) {
                console.error("Erro ao salvar horários:", error);
                toast.error("Erro ao salvar horários");
            }
            salvandoLoading.value = false;
        };


        return {
            loadingPage,
            horarios,
            novoHorario,
            removerHorario,
            adicionarHorario,
            permissaoEditar,
            resetHorarios,
            salvarHorarios,
            salvandoLoading
        }
    }
}
</script>